/**
 * Hero page-load animation
 * Background scales 0.95 → 1, then title / subtitle / buttons stagger in.
 */
export function initHeroAnimation() {
    const gsap = window.gsap;
    if (!gsap || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const hero = document.querySelector('.hero-widget');
    if (!hero) return;

    const row      = hero.querySelector('.row');
    const title    = hero.querySelector('.hero-title');
    const subtitle = hero.querySelector('.hero-subtitle');
    const buttons  = hero.querySelectorAll('.buttons .btn');

    // Set initial states before first frame so there's no flash
    gsap.set(row, { scale: 0.95, transformOrigin: 'center center' });
    if (title)        gsap.set(title,   { y: 50, opacity: 0 });
    if (subtitle)     gsap.set(subtitle, { y: 35, opacity: 0 });
    if (buttons.length) gsap.set(buttons, { y: 25, opacity: 0 });

    const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    tl.to(row, { scale: 1, duration: 1.6 });

    if (title) {
        tl.to(title, { y: 0, opacity: 1, duration: 0.85 }, '-=1.25');
    }

    if (subtitle) {
        tl.to(subtitle, { y: 0, opacity: 1, duration: 0.75 }, '-=0.65');
    }

    if (buttons.length) {
        tl.to(buttons, { y: 0, opacity: 1, duration: 0.6, stagger: 0.12 }, '-=0.5');
    }
}
